<sm-title-bar pageTitle="{{ 'duty_logs.title' | translate }}" [back]="true" >
</sm-title-bar>
<mat-card >
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light" *ngIf="!loader">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="dutyLogsData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         >
      </sm-data-table>
    </div>
  </mat-card>
  

  
  <ng-template #menuTemplate let-rowvalue>
    
    <button mat-menu-item (click)="openGoogleMaps(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>{{ 'duty_logs.op1_view_location' | translate }}</span>
    </button>
    <!-- <button mat-menu-item *ngIf="rowvalue.status == 1 && rowvalue.toShowType =='parent'" (click)="openAddTime(rowvalue)">
      <mat-icon class="material-icons-outlined">link</mat-icon>
      <span>Add more</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 1" (click)="removeTime(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Remove</span>
    </button> -->
  </ng-template>
  <mat-paginator
  *ngIf="!loader && dutyLogsData.length>0"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator>